'use client';

import React from 'react';
import Image from 'next/image';
import styles from './FeatureBlock.module.scss';
import StyledButton from '@/src/components/StyledButton/StyledButton';

type FeatureBlockProps = {
  title: string;
  text: string;
  imageUrl: string;
  imageAlt?: string;
  imageCaption?: string;
  bgColor?: string;
  backgroundWidth?: string;
  backgroundHeight?: string;
  roundedBackground?: boolean;
  imageWidth?: string;
  imageHeight?: string;
  titleFont?: string;
  textFont?: string;
  captionFont?: string;
  captionBackground?: boolean;
  showButton?: boolean;
  buttonLabel?: string;
  buttonUrl?: string;
  roundedImage?: boolean;
  animation?: string;
  animationDelay?: string;
  darkMode?: boolean;
};

const FeatureBlock = ({
  title,
  text,
  imageUrl,
  imageAlt = '',
  imageCaption = '',
  bgColor = '#f0f0f0',
  backgroundWidth = '75%',
  backgroundHeight = '70%',
  roundedBackground = true,
  imageWidth = '50%',
  imageHeight = 'auto',
  captionBackground = false,
  showButton = false,
  buttonLabel = 'Learn More',
  buttonUrl = '#',
  roundedImage = false,
  animation = 'fade-in',
  animationDelay = '0s',
  darkMode = false,
}: FeatureBlockProps) => {
  return (
    <section
      className={`${styles.featureBlock} ${styles[animation]} ${darkMode ? styles.darkMode : ''}`}
      style={{ transitionDelay: animationDelay, '--background-height': backgroundHeight } as React.CSSProperties}
    >
      <div
        className={styles.featureBlockBackground}
        style={{
          backgroundColor: bgColor,
          width: backgroundWidth,
          height: backgroundHeight,
          borderRadius: roundedBackground ? '20px' : '0',
          left: '6rem',
          transform: 'translateY(-50%)',
        }}
      />

      <div className={styles.featureContent}>
        <div className={styles.featureText}>
          <h2 className={styles.featureTitle}>
            {title}
          </h2>
          <p>{text}</p>
          {showButton && (
            <StyledButton href={buttonUrl}>{buttonLabel}</StyledButton>
          )}
        </div>

        <div className={styles.featureImageWrapper} style={{ width: imageWidth, height: imageHeight }}>
          <Image
            src={imageUrl}
            alt={imageAlt}
            fill
            sizes="(max-width: 768px) 100vw, 50vw"
            className={`${styles.featureImage} ${roundedImage ? styles.rounded : ''}`}
            style={{ objectFit: 'cover' }}
          />
          {imageCaption && (
            <div
              className={`${styles.imageCaption} ${captionBackground ? styles.withBg : ''}`}
            >
              {imageCaption}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default FeatureBlock;
